const SIMPLE_PARSER_TYPES = new Set([
  "text/markdown",
  "text/plain",
  "text/csv",
  "application/json",
  "text/xml",
  "application/xml",
  "text/yaml",
  "application/yaml",
]);

const SIMPLE_PARSER_EXTENSIONS = new Set([
  ".md",
  ".markdown",
  ".txt",
  ".csv",
  ".xls",
  ".xlsx",
  ".4dm",
  ".json",
  ".xml",
  ".yaml",
  ".yml",
]);

export function getParser(mimeType?: string, fileName?: string): "simple" | "landingai" {
  if (mimeType && SIMPLE_PARSER_TYPES.has(mimeType)) return "simple";
  if (fileName) {
    const ext = fileName.slice(fileName.lastIndexOf(".")).toLowerCase();
    if (SIMPLE_PARSER_EXTENSIONS.has(ext)) return "simple";
  }
  return "landingai";
}
